import Rectangle from "./Rectangle";
import Area from "./Area";
import Length from "./Length";
import AbstractShape from "./AbstractShape";

export default class ArchedRectangle extends AbstractShape {
	static NAME = 'arched-rectangle';

	constructor( width, height ) {
		super();

		this.width = width;
		this.height = height;
	}

	get_name() {
		return ArchedRectangle.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.width, this.height );
	}

	get_area() {
		const radius           = this.width.in_mm() / 2;
		const half_circle      = Math.PI * Math.pow( radius, 2 ) * 0.5;
		const rectangle_height = this.height.in_mm() - radius;
		const area             = half_circle + ( this.width.in_mm() * rectangle_height );

		return new Area( area );
	}

	get_circumference() {
		const half_circle_circumference = new Length( Math.PI * this.width.in_mm() / 2 );
		const rectangle_height          = this.height.in_mm() - this.width.in_mm() / 2;
		const rectangle_circumference   = new Length( this.width.in_mm() + ( rectangle_height * 2 ) );

		return new Length( half_circle_circumference.in_mm() + rectangle_circumference.in_mm() );
	}

	get_required_material() {
		const enclosing_rect = this.get_enclosing_rectangle();

		const width  = enclosing_rect.get_width().add( new Length( this.get_material_loss() ) );
		const height = enclosing_rect.get_length().add( new Length( this.get_material_loss() ) );

		return new Rectangle( width, height );
	}

	get_width() {
		return this.width;
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_shortest_side()
		};
	}

	get_dimension_keys() {
		return [ "width", "height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height: this.height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new ArchedRectangle( new Length( primitives.width ), new Length( primitives.height ) );
	}
}
